/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.ActivityLog {
    export class ActivityLogScrollTo implements angular.IDirective {
        scope = {};
        restrict = 'A';
        link = (scope: any, element: any, attrs: angular.IAttributes) => {

            scope.$watch(() => attrs.activityLogScrollTo, (newValue, oldValue) => {
                if (!element.context.parentElement && !attrs.activityLogScrollTo) return;
                let heightOfFirstRow = 0;

                if (element.context.children[0] && element.context.children[0].clientHeight) {
                    heightOfFirstRow = element.context.children[0].clientHeight;
                }

                const parentScrollTo = attrs.indexOfNeededElement * heightOfFirstRow;

                element.context.parentElement.parentElement.scrollTo(0, parentScrollTo);
            });
        };

        constructor(
            protected $timeout
        ) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => new ActivityLogScrollTo($timeout);
            directive.$inject = [
                '$timeout'
            ];

            return directive;
        }
    }

    angular.module('meevo.plugins.activityLog')
        .directive('activityLogScrollTo', ActivityLogScrollTo.factory());
}